import { Unionize } from "fond/types";
import { PurchaseType } from "fond/types/stripe";

export const ChangeType = [PurchaseType.future, PurchaseType.update] as const;
export type ChangeType = Unionize<typeof ChangeType>;
